var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { computed, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
var getTableOrderParam = function (sorter) {
    var direction = sorter.order === 'ascend' || sorter.order === 'asc' ? 'asc' : 'desc';
    return sorter.field && sorter.order ? sorter.field + ',' + direction : undefined;
};
var search = function (item, search, paramsToSearch) {
    if (paramsToSearch === void 0) { paramsToSearch = ['name']; }
    var result = [];
    paramsToSearch.forEach(function (param) {
        var _a;
        var value = (_a = item[param]) !== null && _a !== void 0 ? _a : '';
        if (typeof value === 'string' || typeof value === 'number') {
            var str = value.toString().toLowerCase();
            result.push(str.includes(search.toString().toLowerCase()));
        }
    });
    return result.includes(true);
};
export var DEFAULT_TABLE_SIZE = 10;
export default function useTable(opts) {
    var _a;
    if (opts === void 0) { opts = { size: DEFAULT_TABLE_SIZE, paramsToSearch: ['name'] }; }
    var router = useRouter();
    var route = useRoute();
    var query = computed(function () { return route.query; });
    var order = route.query.order;
    var data = reactive({
        data: [],
        columns: [],
        search: '',
        sorter: route.query.order
            ? {
                field: order === null || order === void 0 ? void 0 : order.split(',')[0],
                order: order === null || order === void 0 ? void 0 : order.split(',')[1],
            }
            : {},
        size: (_a = opts.size) !== null && _a !== void 0 ? _a : DEFAULT_TABLE_SIZE,
        total: undefined,
        current: parseInt(route.query.page) || 1,
    });
    var pagination = computed(function () {
        var _a;
        return ({
            total: (_a = data.total) !== null && _a !== void 0 ? _a : data.data.length,
            current: data.current,
            pageSize: data.size,
            showSizeChanger: false,
            showQuickJumper: false,
            showLessItems: true,
        });
    });
    var computedData = computed(function () {
        var result = data.data;
        result = data.search ? result.filter(function (item) { return search(item, data.search, opts.paramsToSearch); }) : result;
        return sort(result);
    });
    function set(values) {
        data.data = __spreadArray([], values, true);
    }
    function setColumns(columns) {
        data.columns = __spreadArray([], columns, true);
    }
    function updateCurrent(current) {
        data.current = current;
    }
    function updateSorter(sorter) {
        data.sorter = sorter;
    }
    function sort(values) {
        var result = __spreadArray([], values, true);
        var field = data.sorter.field;
        function sortByTwoValues(data, value1, value2, order) {
            if (order === void 0) { order = 'desc'; }
            var isDesc = order === 'desc';
            return data.sort(function (a, b) {
                var n = isDesc ? (a[value1] < b[value1] ? 1 : -1) : a[value1] > b[value1] ? 1 : -1;
                if (a[value1] != b[value1]) {
                    return n;
                }
                return isDesc ? (a[value2] < b[value2] ? 1 : -1) : a[value2] > b[value2] ? 1 : -1;
            });
        }
        if (field) {
            if (data.sorter.order === 'descend') {
                // return result.sort((a: any, b: any) => (a[field] < b[field] ? 1 : -1))
                return sortByTwoValues(result, field, 'created_at', 'desc');
            }
            else
                return sortByTwoValues(result, field, 'created_at', 'asc');
        }
        return result;
    }
    function updateQuery(page, sorter) {
        if (route.name)
            router.replace({ name: route.name, query: __assign(__assign({}, query.value), { page: page, order: getTableOrderParam(sorter) }) });
    }
    return {
        data: data,
        computedData: computedData,
        pagination: pagination,
        set: set,
        setColumns: setColumns,
        updateCurrent: updateCurrent,
        updateSorter: updateSorter,
        updateQuery: updateQuery,
        sort: sort,
    };
}
